import { BaseFilter } from './baseFilters.js';
class BaseFilterGeo extends BaseFilter {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: ''
        });
        Object.defineProperty(this, "type", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: ''
        });
    }
    getName() {
        return this.name;
    }
    setName(name) {
        this.name = name;
    }
    toJson() {
        return {
            name: this.name,
            type: this.type,
            ...this.buildGeoData(),
        };
    }
}
export class FilterGeo extends BaseFilterGeo {
    constructor(name, distance, coordinate) {
        super();
        Object.defineProperty(this, "distance", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "coordinate", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.name = name;
        this.type = 'geoDistance';
        this.distance = distance;
        this.coordinate = coordinate;
    }
    getDistance() {
        return this.distance;
    }
    setDistance(distance) {
        this.distance = distance;
    }
    setCoordinate(c) {
        this.coordinate = c;
    }
    getCoordinate() {
        return this.coordinate;
    }
    buildGeoData() {
        return {
            distance: this.distance,
            ...(this.coordinate ? { ...this.coordinate } : {}),
        };
    }
}
export class FilterGeoWithin extends BaseFilterGeo {
    constructor(name, dots = []) {
        super();
        Object.defineProperty(this, "dots", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.name = name;
        this.type = 'geoWithin';
        this.dots = dots;
    }
    setDots(dots) {
        this.dots = dots;
    }
    getDots() {
        return this.dots;
    }
    buildGeoData() {
        return {
            coordinates: this.dots.map((d) => ({
                lat: d.lat,
                lon: d.lon,
            })),
        };
    }
}
